import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  listNotifications,
  markReadNotifications,
} from "../actions/notificationActions";
import { NOTIFICATION_READ_RESET } from "../constants/notificationConstants";

function Notification() {
  const dispatch = useDispatch();

  const [notificationss, setnotificationss] = useState({});

  const notificationList = useSelector((state) => state.notificationList);
  const { loading, error, notifications } = notificationList;

  const {
    loading: loadingRead,
    error: errorRead,
    success,
  } = useSelector((s) => s.notificationRead);

  const readNotification = (id) => {
    dispatch(markReadNotifications(id));
  };

  useEffect(() => {
    if (notifications === undefined || notifications.length < 1) {
      dispatch(listNotifications());
    }
    if (success) {
      dispatch(listNotifications());
      dispatch({
        type: NOTIFICATION_READ_RESET,
      });
    }
  }, [dispatch, notifications, success]);

  return (
    <>
      <div>
        {loading ? (
          <>loading</>
        ) : (
          <>
            {notifications !== undefined ? (
              <>
                {notifications.map((noti) => {
                  var liikn =
                    "https://www.thesearcheducation.com/Contacts/Edit/" +
                    noti.Contact_Id;
                  var liiknd =
                    "https://www.thesearcheducation.com/Deal/Edit/" +
                    noti.Deal_Id;
                  var liikna =
                    "https://www.thesearcheducation.com/application/details/" +
                    noti.Application_Id;
                  return (
                    <>
                      <div className="output-task-header notification-read">
                        <div className="notification-header">
                          <div className="row">
                            <div className="col-md-8 text-left">
                              <i className="fas fa-bell"></i>
                              <h5>Urgent Invoice Notification</h5>
                            </div>
                            <div className="col-md-4 text-right">
                              <span>
                                {moment(noti.Created_On).format(
                                  "DD MMM YYYY hh:mm:ss"
                                )}
                              </span>
                              {noti.Notification_Seen_Status === 0 ? (
                                <div className="showOnHover">
                                  <a
                                    style={{ color: "blue" }}
                                    onClick={(e) => readNotification(noti.Id)}
                                  >
                                    Mark Read
                                  </a>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12 pl-3 pt-3 assign">
                              <i className="fas fa-user-circle"></i>
                              <p>
                                {noti.Notifications} - {noti.Country}
                              </p>
                              <p>
                                {noti.Notification_Seen_Status === 0 ? (
                                  <i className="fa fa-circle read"></i>
                                ) : (
                                  ""
                                )}
                              </p>
                            </div>
                            <div className="col-md-12 pl-5 assign">
                              <i
                                className="fas fa-user-circle"
                                style={{ fontSize: "20px", color: "black" }}
                              ></i>
                              <a href={liikn} target="_blank" rel="noreferrer">
                                {" "}
                                {noti.ContactName}
                              </a>
                              {noti.Deal_Id === "0" ? (
                                <></>
                              ) : (
                                <>
                                  <br />
                                  <i
                                    className="fas fa-handshake"
                                    style={{ fontSize: "20px", color: "black" }}
                                  ></i>
                                  <a
                                    href={liiknd}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {noti.Deal_Name}
                                  </a>
                                  {noti.Application_Id === "0" ? (
                                    <></>
                                  ) : (
                                    <>
                                      <br />
                                      <i
                                        className="fas fa-file-alt"
                                        style={{
                                          fontSize: "20px",
                                          color: "black",
                                        }}
                                      ></i>
                                      <a
                                        href={liikna}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {" "}
                                        SED{noti.Application_Id}
                                      </a>
                                    </>
                                  )}
                                </>
                              )}
                              <br />
                              {noti.Notification_Seen_Status === 0 ? (
                                <a
                                  href={`/invoice/create?ntid=${noti.Id}`}
                                  target="_blank"
                                >
                                  Create Invoice
                                </a>
                              ) : (
                                ""
                              )}
                            </div>
                            {/* <div className="col-md-12 text-right">
                                                                        <i className="fa fa-ellipsis-h assign"></i>
                                                                    </div> */}
                          </div>
                        </div>
                        {/* <div className="assign-more">
                                                                <div className="row">
                                                                    <div className="col-md-12 pl-3 assign assign-more-head">
                                                                        <i className="fas fa-pencil-alt"></i>
                                                                        <p> You have been assigned 4 contacts</p>
                                                                    </div>

                                                                </div>
                                                            </div> */}
                      </div>
                      <hr />
                    </>
                  );
                })}
              </>
            ) : (
              <>{error}</>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Notification;
